import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '../layout/MainLayout';
import Login from '../view/Login';
import IdSearch from '../view/IdSearch';
import IdSearchResult from '../view/IdSearchResult';
import PasswordSearch from '../view/PasswordSearch';
import PasswordSearchResult from '../view/PasswordSearchResult';
import SignUp from '../view/SignUp';
import DispatchList from '../view/DispatchList';
import MyRoomList from '../view/MyRoomList';
import RoomDetail from '../view/RoomDetail';
import WorkNumManage from '../view/WorkNumManage';
import MyInfor from '../view/MyInfor';
import useTokenUpdate from '../hooks/useTokenUpdate';
import SocketIo from '../component/Socket.IO';
import AutoLogin from '../view/AutoLogin';
import AdminLayout from '../layout/AdminLayout';
import AdminLogin from '../view/admin/AdminLogin';
import UserList from '../view/admin/UserList';
import History from '../view/admin/History';
import PrivacyPolicyForm from '../component/privacy/PrivacyPolicyForm';

const isAuthenticated = () => {
  const token = localStorage.getItem('userInfor');
  return !!token;
};

const isNoneToken = () => {
  const token = sessionStorage.getItem('accessToken');
  return !token;
};

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const token = sessionStorage.getItem('accessToken');

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

const Router = () => {
  useTokenUpdate();

  return (
    <>
      <Routes>
        {/* 앱 */}
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Navigate to="/autologin" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route path="/privacy/privacypolicy" element={<PrivacyPolicyForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/autologin" element={<AutoLogin />} />
        <Route path="/idsearch" element={<IdSearch />} />
        <Route path="/idsearchresult" element={<IdSearchResult />} />
        <Route path="/passwordsearch" element={<PasswordSearch />} />
        <Route
          path="/passwordsearchresult"
          element={<PasswordSearchResult />}
        />
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/privacy"
          element={<Navigate to="/privacy/privacy_form.html" replace />}
        />
        <Route element={<MainLayout />}>
          <Route path="/dispatchlist" element={<DispatchList />} />
          <Route path="/myroomlist" element={<MyRoomList />} />
          <Route path="/worknummanage" element={<WorkNumManage />} />
          <Route path="/myinfor" element={<MyInfor />} />
        </Route>
        <Route path="/roomdetail/:id" element={<RoomDetail />} />

        {/* 관리자 */}
        <Route
          path="/admin"
          element={
            isNoneToken() ? (
              <Navigate to="/admin/login" />
            ) : (
              <Navigate to="/admin/userlist" />
            )
          }
        />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          <Route
            path="/admin/userlist"
            element={
              <ProtectedRoute>
                <UserList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/history"
            element={
              <ProtectedRoute>
                <History />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>

      {/* 소켓 */}
      {!location.pathname.startsWith('/admin') && <SocketIo />}
    </>
  );
};

export default Router;
